var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "site-footer" }, [
      _c("div", { staticClass: "site-footer-legal" }, [
        _vm._v(" © 2020 "),
        _c(
          "a",
          { attrs: { href: "https://www.pmi.com/markets/thailand/th" } },
          [_vm._v("PMI (TH)")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }